import { BasicRequest } from "./basicRequest";

export class MoovInstancesRequest extends BasicRequest{
    public moovInstanceIdList: number[] =[];
}